import { endpoints } from './../../../environments/environment';
import { AccountEvolution } from './models/account-evolution';
import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { Application } from './models/application';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Tips } from './models/tips';

@Injectable()
export class DashboardService {

	public static dashboardBarcode: string;

	private messageSource: BehaviorSubject<string> = new BehaviorSubject<string>('');
	currentMessage = this.messageSource.asObservable();

	accountEvolution: AccountEvolution = new AccountEvolution();
	applications: Array<Application>;

	listTips: Array<Tips>;

	emitterInvestments = new EventEmitter<boolean>();


	constructor(private http: HttpClient) { }

	getAccountEvolution(receivedData: any) {

		const beginDate = moment(new Date().setDate(new Date().getDate() - 30)).format('YYYY-MM-DD');
		const endDate = moment(new Date()).format('YYYY-MM-DD');

		const params = new HttpParams()
			.set('dataIni', beginDate)
			.set('dataFim', endDate);

		this.http.get(endpoints.accounts.evolution, { params }).subscribe((data: any) => {

			this.accountEvolution = new AccountEvolution();

			if (data.Sucesso) {

				for (let i = 0; i < data.Retorno.length; i++) {
					let ticksCount = 0;
					this.accountEvolution.labels.push(moment(data.Retorno[i].Data).format('DD/MM'));
					this.accountEvolution.typeValue.push(data.Retorno[i].tipoValor);

					if (data.Retorno[i].tipoValor === 'negativo') {
						const newValue = data.Retorno[i].Valor * -1;

						this.accountEvolution.values.push(newValue);
					} else {
						this.accountEvolution.values.push(data.Retorno[i].Valor);
					}

					for (let j = 0; j < this.accountEvolution.ticks.length; j++) {
						if (this.accountEvolution.ticks[j] === data.Retorno[i].Valor && this.accountEvolution.typeValue[j] === data.Retorno[i].tipoValor) {
							ticksCount++;
						}
					}

					if (ticksCount === 0) {
						if (data.Retorno[i].tipoValor === 'negativo') {
							const newTicks = data.Retorno[i].Valor * -1;

							this.accountEvolution.ticks.push(newTicks);
						} else {
							this.accountEvolution.ticks.push(data.Retorno[i].Valor);
						}
					}
				}


			}

			receivedData(this.accountEvolution);

		});
	}


	changeMessage(message: string) {
		this.messageSource.next(message);
	}

	getTotalTransactions(type: string): Observable<number> {

		const dateBegin = moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD');
		const dateEnd = moment(new Date()).format('YYYY-MM-DD');

		const params = new HttpParams()
			.set('status', type)
			.set('dataInicial', dateBegin)
			.set('dataFinal', dateEnd);

		return this.http.get(endpoints.transactions.all, { params }).pipe(map((data: any) => {
			const transactions = data.Retorno.filter(item => {
				return item.Situacao === 'pendenteAprovacao';
			});

			return transactions.length;
		}));

	}

	getTips(): Observable<Tips[]> {

		return this.http.get(endpoints.accounts.tips).pipe(map((data: any) => {

			if (data.Sucesso) {
				if (data.Retorno.length) {
					this.listTips = data.Retorno.map(item => {

						const tip = new Tips();

						tip.message = item.Texto;
						tip.tipId = item.ID;

						switch (item.Tipo) {
							case 'temMensagemGeral':
								tip.url = '';
								tip.label = '';
								tip.button = false;
								break;
							case 'temSaldoMaior':
								tip.url = '/investimentos/simulacao';
								tip.label = 'Investimentos';
								tip.button = true;
								break;
							case 'temLancamentosFuturos':
								tip.url = '/extrato/lancamentos-futuros';
								tip.label = 'Lançamentos futuros';
								tip.button = true;
								break;
							case 'naoTemNomeVinculado':
								tip.url = '/minha-conta/renomear-conta';
								tip.label = 'Renomear esta conta';
								tip.button = true;
								break;
							default:
								tip.url = '',
									tip.button = false;
								break;
						}

						return tip;
					});

				}
			} else {
				this.listTips = [];
			}

			return this.listTips;

		}));
	}

	removeTip(idTip: number): Observable<any> {
		return this.http.post(endpoints.accounts.tips + idTip, null);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/dashboard/dashboard.service.ts